<div class="one-column-page">
  <div class="one-column-content">
    <h1 class="header-text">{{'ACC_ADMIN.ADMIN' | anessaTranslation: trigger}}</h1>
    <div *ngIf="permissionsData && projectsDone && usersDone"
         class="flex-container flow-column page-container"
    >
      <mat-form-field
        appearance="outline"
        floatLabel="always">
        <mat-label>{{'ACC_ADMIN.USER' | anessaTranslation: trigger}}</mat-label>
        <mat-select
          panelClass="user-select-panel"
          disableOptionCentering
          [placeholder]="('ACC_ADMIN.SELECT' | anessaTranslation: trigger)"
          [(ngModel)]="selectedUser"
          (ngModelChange)="onUserChange()">
          <ngx-mat-select-search
            [placeholderLabel]="'ACC_ADMIN.SEARCH' | anessaTranslation: trigger"
            [noEntriesFoundLabel]="'ACC_ADMIN.NO_USERS' | anessaTranslation: trigger"
            ngModel
            (ngModelChange)="filterUsers($event)"
            name="user-search">
            <i class="material-icons" ngxMatSelectSearchClear>clear</i>
          </ngx-mat-select-search>
          <mat-option
            *ngFor="let user of filteredUsers"
            [value]="user">
            {{ user.name }}
          </mat-option>
        </mat-select>
      </mat-form-field>
      <div *ngIf="selectedUser" class="permissions-container">
        <div class="project-list">
          <mat-list role="list">
            <mat-list-item role="listitem" class="search-list-item">
              <div class="flex">
                <mat-form-field floatLabel="never">
                  <input
                    matInput
                    [(ngModel)]="projectFilter"
                    (ngModelChange)="filterProjects($event)"
                    [placeholder]="('ACC_ADMIN.SEARCH_PROJ' | anessaTranslation: trigger)"
                    autocomplete="off"
                    type="text">
                </mat-form-field>
                <mat-icon class="clickable" (click)="clearProjectFilter()">clear</mat-icon>
              </div>
            </mat-list-item>
            <mat-list-item
              *ngFor="let project of filteredProjects"
              [ngClass]="{ 'item-selected': selectedProject === project }"
              class="highlight-item"
              role="listitem"
              (click)="onProjectChange(project)">
              {{ project.title }}
            </mat-list-item>
            <mat-list-item *ngIf="filteredProjects.length === 0">{{'ACC_ADMIN.NO_PROJ' | anessaTranslation: trigger}}</mat-list-item>
          </mat-list>
        </div>
        <div *ngIf="selectedProject" class="permissions-selection">
          <div>
            <h3 class="project-name">{{ selectedProject.title }}</h3>
            <div class="project-permissions">
              <div class="permission-checkboxes">
                <mat-checkbox
                  *ngFor="let permissionName of permissionNames; let i = index"
                  (change)="onPermissionChange(permissionTypes[i], $event.checked)"
                  [matTooltip]="getCheckboxTooltip(permissionTypes[i])"
                  [disabled]="shouldDisablePermissionCheckbox(permissionTypes[i])"
                  [checked]="permissionValues[permissionTypes[i]]">
                  {{ permissionName }}
                </mat-checkbox>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="fatbuttongroup flex-container">
        <button class="btn-fat btn-green flex-box"
                mat-button=""
                (click)="onSave()"
                anessaTranslation="PROJECT.COMMON.SAVE"
        >
        </button>
        <button class="btn-fat btn-red flex-box"
                mat-button=""
                (click)="cancel()"
                type="button"
                anessaTranslation="PROJECT.COMMON.CANCEL">
        </button>
      </div>
    </div>
  </div>
</div>
